import { notifyHandledException } from '../utils/errorLogger';

function getItemsCount(quantityInputs: NodeListOf<HTMLInputElement>): number {
  return Array.from(quantityInputs).reduce(
    (sum, el) => sum + parseInt(el.value || '0'),
    0
  );
}

function updateSummary() {
  const totals = Array.from(
    document.querySelectorAll('.wholesale-order__product .total')
  );
  const subtotal = totals.reduce((sum, el) => {
    const amount = parseFloat(el.textContent?.replace('$', '') || '0');
    return sum + amount;
  }, 0);

  const summary = document.querySelector<HTMLElement>(
    '.summary .line:first-of-type span:last-of-type'
  );

  const itemCount = getItemsCount(
    document.querySelectorAll<HTMLInputElement>('.quantity input')
  );

  if (summary instanceof HTMLElement) {
    summary.textContent = `$${subtotal}`;
  }

  const summaryTitle = document.querySelector('.line--subtotal .line__label');

  if (summaryTitle instanceof HTMLElement) {
    summaryTitle.textContent = `Subtotal (${itemCount} items)`;
  }
}

function initWholesaleOrderForm(): void {
  const products = document.querySelectorAll('.wholesale-order__product');
  products.forEach((product) => {
    const minusBtn = product.querySelector('.quantity__decrement');
    const plusBtn = product.querySelector('.quantity__increment');
    const quantityEl =
      product.querySelector<HTMLInputElement>('.quantity input');
    const priceEl = product.querySelector('.price');
    const totalEl = product.querySelector('.total');

    if (!(priceEl instanceof HTMLElement)) {
      return;
    }

    const price = parseFloat(priceEl.textContent?.replace('$', '') || '0');

    if (!(quantityEl instanceof HTMLInputElement)) {
      return;
    }

    const updateTotals = () => {
      const quantity = parseInt(quantityEl.value || '0');

      if (totalEl instanceof HTMLElement) {
        totalEl.textContent = `$${(quantity * price).toFixed(0)}`;
      }

      updateSummary();
    };

    updateTotals();
    quantityEl.addEventListener('change', () => {
      updateTotals();
    });

    const incrementHTMLNumberInput = (el: HTMLInputElement) => {
      const currentValue = parseInt(el.value || '0');
      el.value = (currentValue + 1).toString();
    };

    const decrementHTMLNumberInput = (el: HTMLInputElement) => {
      const currentValue = parseInt(el.value || '0');
      if (currentValue > 0) {
        el.value = (currentValue - 1).toString();
      }
    };

    minusBtn?.addEventListener('click', () => {
      decrementHTMLNumberInput(quantityEl);
      updateTotals();
    });

    plusBtn?.addEventListener('click', () => {
      incrementHTMLNumberInput(quantityEl);
      updateTotals();
    });
  });
}

async function clearCart() {
  return fetch('/cart/clear.js', {
    method: 'POST',
    credentials: 'same-origin',
  });
}

function serializeFormData(fromData: FormData): Record<string, any> {
  const result: Record<string, any> = {};

  fromData.forEach((value, key) => {
    const match = key.match(/(.+)\[(\d+)\]\[(.+)\]/);
    if (match) {
      const [, baseKey, index, subKey] = match;
      if (!result[baseKey]) {
        result[baseKey] = [];
      }
      if (!result[baseKey][index]) {
        result[baseKey][index] = {};
      }
      result[baseKey][index][subKey] = value;
    } else {
      if (result[key]) {
        if (!Array.isArray(result[key])) {
          result[key] = [result[key]];
        }
        result[key].push(value);
      } else {
        result[key] = value;
      }
    }
  });

  return result;
}

function createB2BOrderCart(
  wholeSaleOrderForm: HTMLFormElement
): Promise<Response> {
  const formData = new FormData(wholeSaleOrderForm);
  const items = serializeFormData(formData);

  return fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    credentials: 'same-origin',
    body: JSON.stringify(items),
  });
}

function showPopupWithContinueToCheckoutButton() {
  const popup = document.createElement('div');
  popup.className = 'b2b-order-popup';
  popup.innerHTML = `
    <div class="popup-content">
      <h2>Order Created Successfully</h2>
      <p>Your order has been created. Click the button below to continue to checkout.</p>
      <a href="/checkout" class="btn button-primary">Continue to Checkout</a>

       <style>
          .b2b-order-popup {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.5);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 1000;
            }

          .popup-content {
            background-color: white;
            padding: 20px;
            border-radius: 8px;
            text-align: center;
            max-width: 400px;
            width: 100%;
          }
      </style>
    </div>
  `;

  document.body.appendChild(popup);

  const continueButton = popup.querySelector('#continue-to-checkout');
  continueButton?.addEventListener('click', () => {
    document.body.removeChild(popup);
    window.location.href = '/checkout';
  });
}

async function handleB2BOrderFormSubmissions() {
  const orderForm = document.querySelector<HTMLFormElement>(
    '.wholesale-order > form'
  );

  if (orderForm) {
    const submitButton = orderForm.querySelector('button[type="submit"]');

    orderForm.addEventListener('submit', async (event) => {
      event.preventDefault();
      submitButton?.setAttribute('data-busy', 'true');

      await clearCart();
      await createB2BOrderCart(orderForm);
      window.location.href = '/checkout';
      setTimeout(() => {
        showPopupWithContinueToCheckoutButton();
      }, 2000);

      submitButton?.removeAttribute('data-busy');
    });
  }
}

export function initB2BPDP(): void {
  initWholesaleOrderForm();
  handleB2BOrderFormSubmissions().catch(notifyHandledException);
}
